import { useEffect, useState } from 'react';

import { getAppliedMode, getThemeMode, setThemeMode, subscribeThemeMode } from './themeStore';
import type { AppliedTheme, ThemeMode } from './themeStore';

export function useThemeMode(): [ThemeMode, (mode: ThemeMode) => void] {
  const [mode, setMode] = useState<ThemeMode>(() => getThemeMode());

  useEffect(() => subscribeThemeMode(setMode), []);

  return [mode, setThemeMode];
}

// The surface actually painted. Re-resolves on preference changes and, while on
// 'auto', on live OS theme switches.
export function useAppliedTheme(): AppliedTheme {
  const [applied, setApplied] = useState<AppliedTheme>(() => getAppliedMode());

  useEffect(() => {
    const sync = () => setApplied(getAppliedMode());
    const unsubscribe = subscribeThemeMode(sync);
    const mq =
      typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia('(prefers-color-scheme: dark)')
        : null;
    mq?.addEventListener('change', sync);
    return () => {
      unsubscribe();
      mq?.removeEventListener('change', sync);
    };
  }, []);

  return applied;
}
